import { Parser, Player } from 'svga';
import { Video } from 'svga/dist/types';

interface IConfig {
    maxRetryCount: number;
    resourceList: IResourceItem[];
}
export interface IResourceItem {
    /** 资源类型 */
    type: 'img' | 'svga' | 'font';
    /** 文件名称 - 资源预加载用于后续使用的name */
    name: string;
    /** 资源 */
    src: string;
}

interface ICompleteItem extends IResourceItem {
    data: Video;
}
export class PreloadClass {
    /** 预加载失败最大重试次数 */
    maxRetryCount: IConfig['maxRetryCount'];
    /** 预加载资源列表 */
    resourceList: IConfig['resourceList'] = [];
    /** 视频资源 */
    resourceListMp4: IConfig['resourceList'] = [];
    /** 预加载资源列表长度 */
    resourceLength: number;
    /** 已完成加载的数量 */
    loadedCount = 0;
    /** 预加载完成回调 */
    onComplete?: () => void;
    /** 单个资源加载完成回调 */
    onCompleteItem?: (res: ICompleteItem) => void;
    constructor(options: IConfig) {
        this.maxRetryCount = options.maxRetryCount;
        this.resourceLength = options.resourceList.length;
        this.resourceList = options.resourceList;
    }
    /** 加载进度 */
    get progress() {
        return Math.floor((this.loadedCount / this.resourceLength) * 100);
    }
    // 预加载图片
    preloadImg(src: string, retryCount = 0): Promise<void> {
        return new Promise((resolve) => {
            if (retryCount >= this.maxRetryCount) {
                resolve();
                return;
            }
            const img = new Image();
            img.src = src;
            img.onload = () => {
                resolve();
            };
            img.onerror = () => {
                this.preloadImg(src, retryCount + 1);
            };
        });
    }
    async preloadSvga(src: string, retryCount = 0) {
        if (retryCount >= this.maxRetryCount) {
            return;
        }
        const parser = new Parser({ isDisableWebWorker: true, isDisableImageBitmapShim: true, });
        try {
            const _res = await parser.load(src);
            parser.destroy();
            return _res;
        } catch (er) {
            console.error(src, er);
            this.preloadSvga(src, retryCount + 1);
        }
    }
    async preloadFont(item: IResourceItem, retryCount = 0) {
        if (retryCount >= this.maxRetryCount) {
            return;
        }
        if (document.fonts) {
            try {
                await document.fonts.load(`16px '${item.name}'`);
                console.log('--load font', item.name);
            } catch (er) {
                console.log('--load font error', er);
                this.preloadFont(item, retryCount + 1);
            }
        } else {
            const font = new FontFace('FontName', `url(${item.src})`);
            try {
                await font.load();
                console.log('--load font2', item.src);
            } catch (er) {
                console.log('--load font2 error', er);
                this.preloadFont(item, retryCount + 1);
            }
        }
    }
    loadProgressRise() {
        this.loadedCount++;
        if (this.loadedCount >= this.resourceLength) {
            this.onComplete && this.onComplete();
        }
    }
    async loadItem(item: IResourceItem) {
        switch (item.type) {
            case 'img':
                await this.preloadImg(item.src).then(() => {});
                break;
            case 'svga':
                const res = await this.preloadSvga(item.src);
                this.onCompleteItem && this.onCompleteItem({ ...item, data: res!, });
                break;
            case 'font':
                await this.preloadFont(item);
                break;
        }
        this.loadProgressRise();
    }
    preloadMp4() {
        if (this.resourceListMp4.length === 0) {
            return;
        }
        window.requestIdleCallback((res) => {
            this.processChunk(this.resourceListMp4, res);
        });
    }
    async processChunk(list: IResourceItem[], deadline: IdleDeadline) {
        if (list.length === 0 || this.loadedCount >= this.resourceLength) {
            return;
        }
        while (list.length > 0 && deadline.timeRemaining() > 5) {
            const _item = list.shift()!;
            this.loadItem(_item).then(() => {});
        }
        if (this.resourceList.length > 0) {
            window.requestIdleCallback((res) => {
                this.processChunk(list, res);
            });
        }
    }
    initPreload() {
        if (this.resourceList.length === 0) {
            this.onComplete && this.onComplete();
            return;
        }
        window.requestIdleCallback((res) => {
            this.processChunk(this.resourceList, res);
        });
    }
}
